import setMinutes from "date-fns/setMinutes";

// Helper function to format the time as "HH:MM"
export function formatTime(date: Date) {
  let hours = date.getHours().toString().padStart(2, "0");
  let minutes = date.getMinutes().toString().padStart(2, "0");
  return hours + ":" + minutes;
}

// Helper function to generate a new time by adding 1 minute to the current time
export function generateNewTime(notIncludeTime: string[]) {
  let date = setMinutes(new Date(Date.now()), 60);
  let currentHour = date.getHours();

  if (notIncludeTime.includes(formatTime(date))) {
    currentHour++;
  }

  while (notIncludeTime.includes(formatTime(date))) {
    date.setHours(currentHour++);
  }

  // Add 12 hours to the current time
  date.setHours(date.getHours() + 12);

  return date;
}
